import { render, staticRenderFns } from "./user-document-transfer.vue?vue&type=template&id=ac280afe&"
import script from "./user-document-transfer.vue?vue&type=script&lang=js&"
export * from "./user-document-transfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports